import LazyImage from './lazy-image.component'

export default LazyImage
